var _excluded = ["isOpen", "closeModal", "openModal", "children", "allowClose", "size", "zIndex"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable react/jsx-no-constructed-context-values */
import * as React from 'react';
import { Backdrop } from '@creditas-ui/backdrop';
import * as Dialog from './shared';
import { Wrapper } from './ModalRoot.style';
import { ModalContext } from './context';
export var ModalRoot = _ref => {
  var {
    isOpen,
    closeModal,
    openModal,
    children,
    allowClose = true,
    size = 'medium',
    zIndex = 1
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      isOpen,
      closeModal,
      openModal,
      allowClose
    }
  }, /*#__PURE__*/React.createElement(Dialog.Root, {
    modal: true,
    open: isOpen,
    onOpenChange: () => allowClose && closeModal && closeModal()
  }, /*#__PURE__*/React.createElement(Dialog.Portal, null, /*#__PURE__*/React.createElement(Dialog.Overlay, null, /*#__PURE__*/React.createElement(Backdrop, {
    open: true,
    alignItems: "center",
    justifyContent: "center",
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    size: size,
    children: children
  }, rest)))))));
};
//# sourceMappingURL=ModalRoot.js.map